import { useEffect, useMemo, useState } from "react";
import { debounce } from "lodash";

export default function useDebouncedSearch(delay = 300) {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  const setInput = useMemo(
    () =>
      debounce((value) => {
        setDebouncedValue(value.trim());
      }, delay),
    [delay]
  );

  useEffect(() => {
    return () => {
      setInput.cancel();
    };
  }, [setInput]);

  const handleChange = (value) => {
    setInputValue(value);
    setInput(value);
  };

  const reset = () => {
    setInputValue("");
    setDebouncedValue("");
  };

  return { inputValue, debouncedValue, handleChange, reset };
}
